module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Button.js"));
	}, "Button");
}